import { render, staticRenderFns } from "./Ongkir.vue?vue&type=template&id=6ee989bc&"
import script from "./Ongkir.vue?vue&type=script&lang=js&"
export * from "./Ongkir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports